import React, { Component } from 'react';
import Family from '../HocComponent';

// Member details for ChildB (Kid)
const memberDetails = {
    type: 'kid',
    myage: '6years',
    rashi: 'mashe'
};

/**
 * ChildB family member component - represents a kid
 * Enhanced by the Family HOC with age management and modal functionality
 */
class ChildBHoc extends Component {
    render() {
        const { mydetail, age, incrementAge } = this.props;
        const details = { ...mydetail };

        return (
            <div className="family-member">
                <div className="py-4">
                    <div className="justify-content-center">
                        <div className="">
                            <div className="card">
                                <div className="card-header bg-success text-white text-left">
                                    <h1 className="card-title mb-1 text-white">
                                        <i className="fas fa-child mr-2"></i>
                                        ChildB's Adventure Zone
                                    </h1>
                                    <small className="text-light">The Energetic Kid of the Family</small>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-8 text-left">
                                            <div className="profile-section mb-4">
                                                <div className="profile-avatar mb-3">
                                                    <div className="avatar-circle bg-success text-white d-inline-flex align-items-center justify-content-center">
                                                        <i className="fas fa-child fa-2x"></i>
                                                    </div>
                                                </div>
                                                <h2 className="text-dark">My name is ChildB</h2>
                                                <h3 className="text-muted">Current Age: <span className="badge badge-success badge-lg">{age}</span></h3>
                                            </div>

                                            <div className="action-section mb-4">
                                                <button
                                                    onClick={incrementAge}
                                                    className="btn btn-success btn-lg px-4"
                                                    type="button"
                                                    aria-label={`Increment ChildB's age, currently ${age}`}
                                                >
                                                    <i className="fas fa-rocket mr-2"></i>
                                                    Level Up: {age}
                                                </button>
                                            </div>

                                            <h3 className="text-success mt-4 mb-3">Adventure Awaits!</h3>
                                            <p className="lead">
                                                Welcome to the exciting world of adventure and discovery! As the energetic kid
                                                of the family, ChildB represents curiosity, playfulness, and endless energy.
                                                This component showcases dynamic design elements perfect for an active child's personality.
                                            </p>

                                            <h4 className="text-success mt-4 mb-3">Kid Characteristics</h4>
                                            <ul className="list-unstyled">
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Adventure-themed interface with interactive elements
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Energetic color scheme and dynamic icons
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Game-like interaction patterns and feedback
                                                </li>
                                                <li className="mb-2">
                                                    <i className="fas fa-check-circle text-success mr-2"></i>
                                                    Enhanced by Family HOC pattern
                                                </li>
                                            </ul>

                                            <div className="fun-section mt-4 p-3 bg-light rounded">
                                                <h5 className="text-success mb-3">
                                                    <i className="fas fa-heart mr-2"></i>
                                                    Fun Facts
                                                </h5>
                                                <p className="text-dark mb-0">
                                                    <i className="fas fa-quote-left mr-2 text-success"></i>
                                                    I love playing games, learning new things, and exploring the world around me!
                                                    Every day is a new adventure waiting to happen!
                                                    <i className="fas fa-quote-right ml-2 text-success"></i>
                                                </p>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="bg-light p-4 rounded">
                                                <h3 className="text-success mb-3">
                                                    <i className="fas fa-info-circle mr-2"></i>
                                                    Profile Details
                                                </h3>
                                                <div className="member-details">
                                                    <div className="detail-item mb-3 p-3 bg-white rounded">
                                                        <h4 className="h5 mb-1">
                                                            <i className="fas fa-user-tag text-success mr-2"></i>
                                                            Type
                                                        </h4>
                                                        <span className="text-dark text-capitalize">{details.type}</span>
                                                    </div>
                                                    <div className="detail-item mb-3 p-3 bg-white rounded">
                                                        <h4 className="h5 mb-1">
                                                            <i className="fas fa-birthday-cake text-success mr-2"></i>
                                                            Age Category
                                                        </h4>
                                                        <span className="text-dark">{details.myage}</span>
                                                    </div>
                                                    <div className="detail-item mb-3 p-3 bg-white rounded">
                                                        <h4 className="h5 mb-1">
                                                            <i className="fas fa-star text-success mr-2"></i>
                                                            Rashi
                                                        </h4>
                                                        <span className="text-dark text-capitalize">{details.rashi}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-5 text-left">
                                        <h3 className="text-success mb-3">Adventure Features</h3>
                                        <p>
                                            ChildB's component demonstrates how the Family HOC can be customized for different
                                            personalities while maintaining consistent core functionality across all family members.
                                        </p>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="feature-card p-3 border rounded mb-3">
                                                    <h4 className="h5 text-success">
                                                        <i className="fas fa-gamepad mr-2"></i>
                                                        Interactive Play
                                                    </h4>
                                                    <p className="mb-0 text-muted">
                                                        Game-like interactions and playful feedback systems designed for active engagement.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="feature-card p-3 border rounded mb-3">
                                                    <h4 className="h5 text-success">
                                                        <i className="fas fa-compass mr-2"></i>
                                                        Exploration Theme
                                                    </h4>
                                                    <p className="mb-0 text-muted">
                                                        Adventure-themed design elements that encourage discovery and learning.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="feature-card p-3 border rounded mb-3">
                                                    <h4 className="h5 text-success">
                                                        <i className="fas fa-trophy mr-2"></i>
                                                        Achievement System
                                                    </h4>
                                                    <p className="mb-0 text-muted">
                                                        Level-up mechanics and achievement-based interactions for motivation.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Set display name for debugging
ChildBHoc.displayName = 'ChildBHoc';

export default Family(ChildBHoc, memberDetails);